// extracted by mini-css-extract-plugin
export default {"reports_container":"reports_reports_container__EbCHC"};